import styled from "styled-components";
import { themes } from "../../../theme/theme";

const BlockSegments = styled.div`
  display: flex;
  padding: 0 10%;

  @media ${themes.device.laptop} {
    padding: 0 5%;
  }
  @media ${themes.device.tablet} {
    padding: 0 7%;
    flex-direction: column;
  }
  @media ${themes.device.tabletS} {
    padding: 0 3%;
  }

  .long {
    width: 75%;
    height: 28rem;
    img {
      margin-right: 2%;
    }
    @media ${themes.device.laptop} {
      height: 28rem;
    }

    @media ${themes.device.tablet} {
      width: 100%;
    }
    .droppable {
      height: 70%;
      margin: 0 3%;
      div {
        -ms-overflow-style: none;
      }
      @-moz-document url-prefix() {
        div {
          scrollbar-width: thin;
          div {
            height: auto;
            scrollbar-width: none;
            #cardDivEdit {
              .border {
                min-height: 1.5rem;
              }
            }
          }
        }
      }
      div::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      div::-webkit-scrollbar-thumb {
        background: #7d7d7d;
      }
      div::-webkit-scrollbar-track {
        background-color: transparent;
      }
      button {
        display: none !important;
      }
      .inDroppable {
        height: 100%;
      }
    }
  }
`;

const SegmDiv = styled.div`
  @media (min-width: 1921px) {
    width: 20%;
  }
  overflow: hidden;

  display: flex;
  flex-direction: column;
  width: 30rem;
  margin: 0 1rem;

  @media ${themes.device.tablet} {
    margin: 0;
    width: 100%;
  }
  .inDiv {
    margin-bottom: 1rem;
    width: 100%;
    height: 30rem;

    @media ${themes.device.tablet} {
      height: 28rem;
    }

    .droppable {
      div {
        -ms-overflow-style: none;
      }
      @-moz-document url-prefix() {
        div {
          scrollbar-width: thin;
          div {
            height: auto;
            scrollbar-width: none;
            #cardDivEdit {
              .border {
                min-height: 1.5rem;
              }
            }
          }
        }
      }

      div::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      div::-webkit-scrollbar-thumb {
        background: #7d7d7d;
      }
      div::-webkit-scrollbar-track {
        background-color: transparent;
      }
      height: 70%;
      margin: 0 3%;

      button {
        display: none !important;
      }
      .inDroppable {
        height: 100%;
      }
    }
  }
`;
export { BlockSegments, SegmDiv };
